<template>
    <div>
        <div id="encabezados-tp">
            <h1>Consulta de Audiencias por Juez</h1>
            <h3></h3>
            <!-- <div class="hr-titulo"></div> -->
        </div>


 <div class="container margen-main-GT">
           <div class="row ">
            <!-- <h6>
              <input type="checkbox" v-model="conFecha" />
            </h6> -->
            <div class="fecha col-12 col-lg-4 col-md-12">
             <input type="date" class='form-control' v-model="Fecha"/>
            </div>
             <!-- <div v-if="!PuestoJuridico"> -->
            <div class="col-12 col-lg-4 col-md-12">
             <h6>
               Seleecione Juez
            </h6>

             <select name="Juez" id="Jueces" class='form-control' v-model="juez" @change="llenarTablas" required>
                 <option value="">Seleccione un Juez</option>
                 <option v-for="(dato,index) in ObtenerJueces" :key="index" :value="dato.llave" >{{dato.valor}}</option>                                
             </select>
             </div>
             <!-- </div> -->
             <div class="btnFiltro col-12 col-lg-4 col-md-12">
             <button type="button" class="btn btn-info" @click="llenarTablas">Filtrar</button>
             </div>
 </div>      
</div>
<br><br>
 <div class="margen-main-GT">
            <div id="toolbar-tabla-lista-CJZ">
                <div class="form-inline flex-wrap" style="gap: 2em !important;">
                    <button  type="button" class="btn btn-success" v-if="(listaAudienciasExcel != null && listaAudienciasExcel != undefined && listaAudienciasExcel.length > 0)" @click="ejecutarProcesoGetExcelListaDeAudiencias({ conLoading: true })">
                        <i class="fas fa-file-excel"></i>&nbsp;&nbsp;Descargar excel
                    </button>
                </div>
            </div>
           <h6></h6>
           <table 
                class="table table-striped table-light table-hover letra-grande "
                data-toolbar="#toolbar-tabla-lista-CJZ"
                id='tabla-audiencias_juez'             
                data-toggle="table"
                data-undefined-text="-"      
                data-click-to-select="false"
                data-search="true"
                data-pagination="false"
                data-maintain-meta-data="true"
                data-page-size = "10"
                data-page-list="[5,10,20,30,40, 50, 60, 70, 80, 90, 100, 200, 300, 1000]"
                data-show-toggle="true"
                data-show-pagination-switch="true"
                

                  
               >
           
           <thead  class="thead-dark">
               <tr>
                   <th data-halign="center" data-width="6" data-align="center"  data-field="audiencia_id" data-sortable="true">FOLIO</th>
                   <th data-halign="center" data-width="6" data-align="center"  data-field="NombrePartido" data-sortable="true">PARTIDO</th>
                   <th data-halign="center" data-width="6" data-align="center"  data-field="FechaDeAudiencia" data-sortable="true">FECHA DE AUDIENCIA</th>
                   <th data-halign="center" data-width="6" data-align="center"  data-field="HoraDeAudiencia" data-sortable="true">HORA</th>
                   <th data-halign="center" data-width="6" data-align="center"  data-field="carpeta_alias" data-sortable="true">CARPETA</th>
                   <th data-halign="center" data-width="6" data-align="center"  data-field="salaConModo" data-sortable="true">SALA</th>
                    <th data-halign="center" data-width="6" data-align="center"  data-field="zoom_id" data-sortable="true">ZOOM</th>
                   <th data-halign="center" data-width="6" data-align="center"  data-field="audiencia_auxiliar" data-sortable="true">AUXILIAR</th>
                   <th data-halign="center" data-width="20" data-align="center"  data-field="audiencia_tipo" data-sortable="true">AUDIENCIA</th>
                   <th data-halign="center" data-width="6" data-align="center"  data-field="ConDetenido" data-sortable="true">DETENIDO</th>
                   <!-- <th data-halign="center" data-width="6" data-align="center"  data-field="FechaAgendada" data-sortable="true">AGENDO</th> -->
               </tr>
           </thead>

           </table>
       </div>




       <!-- <div>
           <h6></h6>
           <table 
                class="table table-striped table-light table-hover"
                id='tabla-audiencias'             
                data-toggle="table"
                data-pagination="true"
                data-undefined-text="Sin información"  
                data-page-size = "5"
                data-page-list="[5,10,20]"
                data-click-to-select="false"
                data-search="true"
           >
           <thead  class="thead-dark">
               <tr>
                   <th data-halign="center" data-width="6" data-align="center"  data-field="audiencia_id">FOLIO</th>
                   <th data-halign="center" data-width="6" data-align="center"  data-field="partido_id">PARTIDO</th>
                   <th data-halign="center" data-width="6" data-align="center"  data-field="audiencia_fecha">FECHA DE AUDIENCIA</th>
                   <th data-halign="center" data-width="6" data-align="center"  data-field="audiencia_fecha">HORA</th>
                   <th data-halign="center" data-width="6" data-align="center"  data-field="carpeta_alias">CARPETA</th>
                   <th data-halign="center" data-width="6" data-align="center"  data-field="audiencia_sala">SALA</th>
                   <th data-halign="center" data-width="6" data-align="center"  data-field="audiencia_tipo">AUDIENCIA</th>
                   <th data-halign="center" data-width="6" data-align="center"  data-field="audiencia_detenido">DETENIDO</th>
                   <th data-halign="center" data-width="6" data-align="center"  data-field="audiencia_registrada">AGENDO</th>
               </tr>
           </thead>

           </table>
       </div> -->
    </div>
</template>

<script>
import axios from 'axios';
import api from '@/../static/js/api'
import comun from "@/../static/js/comun"
import {CATALOGOS} from  '../Catalogos/CatalogosBD.js'
import moment from 'moment'
import { servicioRestPost } from '../Programacion/servicios/ServiciosHttp.js'

export default {
    data(){
        return{
            CATALOGOS,
            audiencias:[],
            juez:null,
            conFecha:false,
            Fecha:moment().format('YYYY-MM-DD'),
            PuestoJuridico:0, 
            listaAudienciasExcel: [],
            nombreJuez: null      
        }
    },
    methods:{
        descargarArchivoExcel: function({ arrayBuffer }) {
            let a = document.createElement('a');
            a.href = URL.createObjectURL(new Blob(
                [ arrayBuffer ],
                { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
            ));
            a.download =  `${ this.nombreJuez }-ListaDeAudiencias.xlsx`;
            a.click()
        },
        ejecutarProcesoGetExcelListaDeAudiencias: async function({ conLoading }) {
            if(conLoading)
                comun.SeEstaCargandoInformacion(true);
            try {
                const PETICION_GET_AUDIENCIAS_EXCEL = this.getPeticionGeneracionDeExcel();
                const { CON_ERROR, RESPUESTA }  = await Promise.resolve(servicioRestPost({
                    servicioUrl: api.GestionAudiencias.sistema.programacionAudiencias.consultaJuez.ObtenerListaDeAudienciasExcel,
                    peticionServicio: PETICION_GET_AUDIENCIAS_EXCEL,
                    headers: { TOKEN_AUTORIZACION:this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS: false, HEADER_PARA_ARRAY_BUFFER: true }
                }));

                if(!CON_ERROR && RESPUESTA.byteLength > 0) {
                    this.descargarArchivoExcel({ arrayBuffer: RESPUESTA });
                }
                else {
                   comun.mensajeDeAlerta('Ocurrio un error al exportar la infromacion a excel');
                }

                if(conLoading)
                    comun.SeEstaCargandoInformacion(false);
            }
            catch(e) {
                if(conLoading)
                    comun.SeEstaCargandoInformacion(false);
                console.error(e);
            }
        },
        getPeticionGeneracionDeExcel: function() {
            let peticion = new FormData();
            let audienciasObj = this.listaAudienciasExcel.map(a => {
                let aObj = {};
                aObj.folio = `${ a.audiencia_id }`;
                aObj.partido = `${ a.NombrePartido }`;
                aObj.fechaAudiencia = `${ a.FechaDeAudiencia }`;
                aObj.hora = `${ a.HoraDeAudiencia }`;
                aObj.carpeta = `${ a.carpeta_alias }`;
                aObj.sala = `${ a.audiencia_sala }`;
                aObj.auxiliar = `${ a.audiencia_auxiliar }`;
                aObj.audiencia = `${ a.audiencia_tipo }`;
                aObj.detenido = `${ a.ConDetenido }`;
                aObj.zoom = `${ a.zoom }`;
                aObj.modo = `${ a.modo }`;
                return aObj;
            });
            peticion.append('EsPrueba',false); 
            peticion.append('ListaDeAudiencias',JSON.stringify(audienciasObj)); 
            return peticion;
        },
        llenarTablas:function(){
            if(this.juez != "")
            this.ConsultaAudiencias();
            

        },
        ConsultaAudiencias: async function(){
             let ValidacionCorrecta=false;
             if(this.Fecha!=null && this.juez!=null  && this.juez!="") ValidacionCorrecta=true;
            // if(!this.conFecha && this.juez!=null  && this.juez!="") ValidacionCorrecta=true;
             if(ValidacionCorrecta){
                
            let parametros = {
                Juez:this.juez,
                ConFecha:this.conFecha,
                Fecha:this.Fecha,
                EsJuez:this.PuestoJuridico
            }
            // let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);
            const RESPUESTA = await axios.post(api.conexion+'Audiencias/ConsultaJuez/ObtenerAudienciasJuez',parametros,null);
            this.audiencias = await this.formatoAudiencias(await RESPUESTA.data.Agrupacion)       
          //  await Promise.resolve(this.llenarTablasPorFecha(this.audiencias))
            $("#tabla-audiencias_juez").bootstrapTable({data:this.formatoAudienciasJuez(RESPUESTA.data.Audiencias)});
            $("#tabla-audiencias_juez").bootstrapTable('load',RESPUESTA.data.Audiencias);
            
        
                 
             }else{
               comun.mensajeDeAlerta('Favor de llenar los campos requeridos', null, null);

             }
            //    this.audiencias.forEach(element => {
            //     $("#"+element.Id).bootstrapTable({data:element.Grupo});
            //     $("#"+element.Id).bootstrapTable('load',element.Grupo);
                
                
            // });
        },

        llenarTablasPorFecha:async function(datos){
          
            datos.forEach(element => {
                    element.Grupo.forEach(elem =>{
                        $("#tabla-audiencias").bootstrapTable('insertRow',{index:element.Id,row:elem});

                    }); 
                //      $("#tabla-audiencias").bootstrapTable('insertRow',{index:element.Id,row:{audiencia_fecha:"HOLA"}});
                //  $("#tabla-audiencias").bootstrapTable('mergeCells',{index:element.Id,field:'audiencia_fecha',colspan:4,rowspan:3});
    
                 
               //  $("#tabla-audiencias").bootstrapTable('load',element.Grupo);
              
                
             });
        },

        formatoAudiencias:async function(doc){
            let documento
            documento = doc.map(c => {
                let docFormateado = c;
                docFormateado.Id = c.Key.y +''+c.Key.m +''+ c.Key.d;

                return docFormateado;
            });
            return documento;
        },

          formatoAudienciasJuez:async function(doc){
            let documento
            documento = doc.map(c => { debugger
                let docFormateado = c;
                var NombrePartido =CATALOGOS.partidoJudicial.filter(a=>a.llave==c.partido_id);   
                docFormateado.FechaDeAudiencia =(c.audiencia_fecha!=null)? moment(c.audiencia_fecha,"YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY"):"-";
                docFormateado.HoraDeAudiencia =(c.audiencia_fecha!=null)? moment(c.audiencia_fecha,"YYYY-MM-DD HH:mm:ss").format("HH:mm") :"-";
                docFormateado.NombrePartido = (NombrePartido!=null && NombrePartido[0] != null)?NombrePartido[0].valor:"-";
                docFormateado.FechaAgendada = (c.audiencia_registrada!=null)?moment(c.audiencia_registrada,"YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY"):"-";
                docFormateado.ConDetenido = (c.audiencia_detenido == 1)?"Si":"No";
                docFormateado.zoom = c.zoom_id;
                docFormateado.modo = c.audiencia_modo;
                docFormateado.salaConModo = ((c.audiencia_sala == null)?"":c.audiencia_sala) + " " +((c.audiencia_modo == null)?"":c.audiencia_modo)
                return docFormateado;
            });
            this.listaAudienciasExcel = documento != null && documento != undefined && documento.length > 0 ? documento : [];
            this.nombreJuez = this.juez;
            return documento;
        },


    },
    computed:{
        ObtenerJueces:function(){
            return CATALOGOS.juecesConsultas;
        }
        
    },
    mounted(){
    //    this.PuestoJuridico = (this.$store.getters.Get_PuestoDelUsuario.AreaId == 4)?true:false;
    },
    created(){
    //   window.onresize = function(){
    //       let anchoVentana = window.innerWidth;
    //       if(anchoVentana<991){
    //          let muestra = $("#tabla-audiencias_juez");
    //       }  
    //       else{
    //          // $("#tabla-audiencias_juez").bootstrapTable('toggleView')
    //           //$("#tabla-audiencias_juez").bootstrapTable('toggleView',false)
    //       } 
          
    //   }
    }
}
</script>

<style scoped>
.margen-main-GT {
    padding: 0 3em 0 2em;
}


.letra-grande{
    font-size: 1.5em
}
.fecha{
   margin-top: 27px;
   margin-bottom: 10px;
}
.btnFiltro{
    margin-top:22px;
}
#encabezados-tp {
    margin-bottom: 4em;
    width: 100%;
    text-align: center;
    background-color: rgb(20, 20, 20);
    padding: 1em 0 0.5em 0;
}

#encabezados-tp h1 {
    margin-bottom: 0;
    font-weight: bold;
    font-size: 2.5em;
}

#encabezados-tp h3 {
    font-size: 1.5em;
    color: rgb(175, 175, 175);
}

#encabezados-tp h4 {
    font-size: 1.5em;
    color: rgb(214, 214, 214);
}
.filtros-busqueda {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1em;
    flex-wrap: wrap;
}

</style>




// WEBPACK FOOTER //
// src/components/Audiencias/Consulta/ConsultaJuez.vue